import { render, staticRenderFns } from "./WtSwitchQuestionInput.vue?vue&type=template&id=337b1dce&scoped=true&lang=pug&"
import script from "./WtSwitchQuestionInput.vue?vue&type=script&lang=js&"
export * from "./WtSwitchQuestionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337b1dce",
  null
  
)

export default component.exports